// react
import axios from "axios";
import { UseFormSetValue, UseFormGetValues } from "react-hook-form";
// handlers
import user from "src/components/UI/Shared/user";
import SharedHandler from "src/components/UI/Shared/handler";

interface FormValues {
  user_name: any;
  profession: any;
  first_name: any;
  last_name: any;
  email: any;
  bio: any;
  street: any;
  city: any;
  state: any;
  country: any;
  zip_code: any;
}
class Handler {
  public static check = (value: any) => {
    if (
      value === null ||
      value === "null" ||
      value === undefined ||
      value === "undefined" ||
      value === "" ||
      value === " " ||
      value === "noName"
    )
      return "-";
    else return value;
  };
  public static setValuesWhenBack = (setValue: UseFormSetValue<FormValues>) => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    if (data) {
      const user_data = JSON.parse(data);
      const user_info = user_data["session_token"];
      setValue("user_name", user_info["user_name"]);
      setValue("profession", user_info["profession"]);
      setValue("first_name", user_info["first_name"]);
      setValue("last_name", user_info["last_name"]);
      setValue("email", user_info["email"]);
      setValue("bio", user_info["bio"]);
      setValue("street", user_info["street"]);
      setValue("city", user_info["city"]);
      setValue("state", user_info["state"]);
      setValue("country", user_info["country"]);
      setValue("zip_code", user_info["zip_code"]);
    }
  };
  public static getCompositeAddress = (
    getValues: UseFormGetValues<FormValues>
  ) => {
    const state = getValues("state") === "-" ? "" : getValues("state");
    const country = getValues("country") === "-" ? "" : getValues("country");
    if (state === "" && country === "") return "";
    else if (state === "") return country;
    else if (country === "") return state;
    return state + ", " + country;
  };
  public static updateUserInfo = (
    data: any,
    user_info: any,
    current_user: string
  ) => {
    if (data) {
      const user_data = JSON.parse(data);
      const new_data = user_data;
      new_data["session_token"] = user_info;
      localStorage.setItem(current_user, JSON.stringify(new_data));
    }
  };
  public static updateUserPic = (data: any, pic: any, current_user: string) => {
    const user_data = JSON.parse(data);
    const new_data = user_data;
    new_data.session_token.pic = pic;
    new_data.locked = "unlocked";
    localStorage.setItem(current_user, JSON.stringify(new_data));
  };
}
export default Handler;
export const handleRequest = async (
  apiURL: string,
  endpointUrl: string,
  formData: FormData,
  signature: string,
  timestamp: string,
  optionalParam: string,
  flag?: string
) => {
  const ip = user.parseUserIp();
  formData.append("ip", ip);

  let returned = { flag: "", message: [""] };
  if (optionalParam === "0") {
    endpointUrl = endpointUrl + `?reset=0`;
  }
  await axios
    .post(apiURL + endpointUrl, formData, {
      headers: {
        "Content-Type": flag === "pic" ? "multipart/form-data" : undefined,
        "X-Signature": signature,
        "X-Timestamp": timestamp,
      },
    })
    .then((response) => {
      const response_data = SharedHandler.decodeResponse(response);
      console.log(response_data);
      if (response_data.verification_status) {
        if (response_data.captcha) {
          returned = {
            flag: "TRACKING",
            message: [response_data.verification_status, response_data.captcha],
          };
        } else {
          returned = {
            flag: "TRACKING",
            message: [response_data.verification_status],
          };
        }
      } else if (response.data.error) {
        returned = { flag: "ERROR", message: [response.data.error] };
      } else if (response.data.message === "Updated successfully.") {
        returned = {
          flag: "SUCCESS",
          message: ["User info has been updated successfully."],
        };
      } else if (response.data.message === "Purchased successfully.") {
        returned = {
          flag: "SUCCESS",
          message: [response.data.message],
        };
      } else if (response.data.pic) {
        returned = {
          flag: "SUCCESS_PIC",
          message: [
            "Profile picture has been updated successfully.",
            response.data.pic,
          ],
        };
      } else if (response.data.records) {
        returned = {
          flag: "SUCCESS",
          message: ["History downloaded successfully.", response.data.records],
        };
      } else {
        returned = { flag: "ERROR", message: ["Error happened."] };
      }
    })
    .catch((error) => {
      returned = { flag: "ERROR", message: ["Error happened."] };
    });
  return returned;
};
export const handlePicRequest = async (
  apiURL: string,
  endpointUrl: string,
  formData: FormData,
  signature: string,
  timestamp: string,
  optionalParam: string
) => {
  const ip = user.parseUserIp();
  formData.append("ip", ip);

  let returned = { flag: "", message: [""] };
  if (optionalParam === "0") {
    endpointUrl = endpointUrl + `?reset=0`;
  }
  await axios
    .post(apiURL + endpointUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Signature": signature,
        "X-Timestamp": timestamp,
      },
    })
    .then((response) => {
      const response_data = SharedHandler.decodeResponse(response);
      if (response_data.verification_status) {
        if (response_data.captcha) {
          returned = {
            flag: "TRACKING",
            message: [response_data.verification_status, response_data.captcha],
          };
        } else {
          returned = {
            flag: "TRACKING",
            message: [response_data.verification_status],
          };
        }
      } else if (response.data.error) {
        returned = { flag: "ERROR", message: [response.data.error] };
      } else if (response.data.pic) {
        returned = {
          flag: "SUCCESS",
          message: [
            "Profile picture has been updated successfully.",
            response.data.pic,
          ],
        };
      } else {
        returned = { flag: "ERROR", message: response.data.message };
      }
    })
    .catch((error) => {
      returned = { flag: "ERROR", message: error.message };
    });
  return returned;
};
